import React from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';

import {withStyles} from '@material-ui/core/styles';
import {CustomButton} from '../../material-dashboard-pro-react/components/index';
import {Close} from '../../icons/index';
import style from '../../styles/components/button';

function ButtonClose(props) {
  const {
    classes,
    customClasses,
    onClick,
  } = props;

  return (
    <CustomButton
      color="secondary"
      customClasses={customClasses}
      onClick={onClick}
      size="xs"
    >
      <Close className={classes.button__icon} />
      {I18n.t('buttons.close').toUpperCase()}
    </CustomButton>
  );
}

ButtonClose.propTypes = {
  classes: PropTypes.object.isRequired,
  customClasses: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

ButtonClose.defaultProps = {
  customClasses: '',
};

export default withStyles(style)(ButtonClose);
